import React from 'react';
import { Box } from '@hover/blueprint';
import Heading from './Heading';
import Hero from './Hero';
import ShowCasePartners from '../common/ShowcasePartners';
import { PARTNERS_MEET_MANUFACTURERS } from '../../../constants/partners';

export const Manufactors = () => (
  <Box d="block" w="100%" py={{ base: '80px', desktop: '100px' }}>
    <Heading />
    <Hero />
    <ShowCasePartners partners={PARTNERS_MEET_MANUFACTURERS} />
  </Box>
);
